import { mapQueueNameToReadable } from "../../../utils";

export const copy = {
  assistantMessage:
    "If you do not want to wait for an agent, please select another option.",
  waitMessages: {
    heading: "Connecting you with a live agent...",
    headingForTransferToQueue: (queueName: string) =>
      `Connecting you with a live agent from ${mapQueueNameToReadable(
        queueName
      )}...`,
    estimatedMinutes: (taskQueueEstWaitTimeMinutes: number) =>
      `Your estimated wait time for this live chat is ${
        taskQueueEstWaitTimeMinutes > 1
          ? `${taskQueueEstWaitTimeMinutes} min`
          : "less than a minute"
      }.`,
    nextInLine: "You're next in line!",
  },
};
